import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ThemeState {
  isDark: boolean;
  toggleTheme: () => void;
}

function applyDarkClass(isDark: boolean) {
  if (isDark) {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      isDark: false,
      toggleTheme: () =>
        set((state) => {
          const next = !state.isDark;
          applyDarkClass(next);
          return { isDark: next };
        }),
    }),
    {
      name: 'vivatis-theme',
      version: 1,
      migrate: (persisted, version) => {
        if (version === 0 && typeof persisted === 'boolean') {
          return { isDark: persisted };
        }
        return persisted as ThemeState;
      },
    },
  ),
);

// Sync dark class on store rehydration and state changes
useThemeStore.subscribe((state) => applyDarkClass(state.isDark));
// Apply immediately for SSR/hydration
applyDarkClass(useThemeStore.getState().isDark);
